export type PriceType = {
    priceWithVat: number;
    priceWithoutVat: number;
    vatAmount: number;
    currencyCode: string;
};

export type ProductPriceType = PriceType & {
    isPriceFrom: boolean;
    isActionPrice?: boolean;
    isOldPrice?: boolean;
    isTescomaPrice?: boolean;
    validFrom: Date | null;
    validTo: Date | null;
    b2bRecommendedPrice: number | null;
};

export type ProductPricesType = {
    basic: ProductPriceType;
    special: ProductPriceType | null;
    tescoma: ProductPriceType | null;
};

export type LoyaltyClubPointsWithPriceType = {
    loyaltyClubPoints: number | null;
    loyaltyClubPointsPrice: number | null;
};

export enum PricingHistoryStrategy {
    none = 'none',
    discountedOnly = 'discounted_only',
    allExceptVouchers = 'all_except_vouchers',
}
